import { Alert, Button, Form, Input } from "antd"
import { useState } from "react"
import { Link } from "react-router-dom"
import { MailOutlined } from "@ant-design/icons"
import AuthShell from "../../Layout/AuthShell"
import apiClient from "../../Utils/apiClient"

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)

  const onFinish = async (values) => {
    setLoading(true)
    try {
      await apiClient(
        "auth/forgot-password",
        "POST",
        { email: values.email },
        { refresh: false }
      )
      setSent(true)
    } catch (err) {
      setSent(true)
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthShell
      title="Forgot your password?"
      subtitle="Enter your work email. If an account exists, we’ll send a reset link that expires in 30 minutes."
      footer="For security, the same message is shown whether or not the email is registered."
      badge="Account recovery"
      steps={["Credentials", "Verify", "Console"]}
      activeStep={1}
    >
      {sent ? (
        <Alert
          type="success"
          showIcon
          className="mb-3"
          message="Check your email"
          description="If an account exists for that address, a reset link is on its way. Check spam if you don’t see it within a few minutes."
        />
      ) : (
        <Form
          className="auth-form"
          layout="vertical"
          onFinish={onFinish}
          requiredMark={false}
        >
          <Form.Item
            label="Work email"
            name="email"
            rules={[
              { required: true, message: "Please enter your email" },
              { type: "email", message: "Please enter a valid email" },
            ]}
          >
            <Input
              size="large"
              prefix={<MailOutlined className="text-muted" />}
              placeholder="you@company.com"
              autoComplete="email"
            />
          </Form.Item>
          <Form.Item className="mb-0">
            <Button
              className="auth-submit"
              type="primary"
              htmlType="submit"
              block
              size="large"
              loading={loading}
            >
              Send reset link
            </Button>
          </Form.Item>
        </Form>
      )}
      <div className="text-center mt-3">
        <Link to="/login">Back to sign-in</Link>
      </div>
    </AuthShell>
  )
}

export default ForgotPassword
